<template>
  <el-form class="ghost-button-styles" ref="formRef" :rules="rules" :model="targetingForm" :label-width="labelWidth">
    <el-form-item label="定向类型">
      <el-radio-group v-model="targetingForm.ad_marketing_scene" :disabled="adMarketingSceneDisabled" @change="onAdMarketingSceneChange">
        <el-radio-button ghost :label="TOUTIAO_AD_MARKETING_SCENE.VERSION_2">头条2.0定向</el-radio-button>
        <el-radio-button ghost :label="TOUTIAO_AD_MARKETING_SCENE.VERSION_3">头条智擎定向</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <template v-if="isToutiaoV3">
      <template v-if="isAdd">
        <el-form-item label="定向包名称" prop="name">
          <el-input style="width: 320px" v-model="targetingForm.name"></el-input>
        </el-form-item>

        <el-form-item label="描述">
          <el-input style="width: 320px" type="textarea" v-model="targetingForm.description"></el-input>
        </el-form-item>

        <el-form-item label="账号选择">
          <el-select v-model="targetingForm.account" value-key="id" filterable style="width: 320px" @change="onAccountChange">
            <el-option v-for="account in accountList" :key="account.id" :label="account.name" :value="account"></el-option>
          </el-select>
          <p v-if="accountNotExsitMsg" style="color: red">{{ accountNotExsitMsg }}</p>
        </el-form-item>
      </template>

      <el-form-item label="人群包">
        <el-radio-group v-model="targetingForm.audienceType" @change="onAudienceTypeChange">
          <el-radio-button ghost :label="AUDIENCE_TYPE.UNLIMITED">不限</el-radio-button>
          <el-radio-button ghost :label="AUDIENCE_TYPE.AUDIENCE">定向或排除人群</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="targetingForm.audienceType === AUDIENCE_TYPE.AUDIENCE">
        <AudiencesTable
          v-if="Object.keys(targetingForm.audiences).length"
          :value="targetingForm.audiences"
          :data="audienceData"
          :accounts="[targetingForm.account]"
          @change="onAudienceResultChange"
        >
          <el-table-column prop="userCount" show-overflow-tooltip width="90" label="覆盖数量"></el-table-column>
        </AudiencesTable>
        <div v-else>请先选择账号</div>
      </el-form-item>

      <el-form-item label="地域">
        <el-radio-group v-model="targetingForm.regionType">
          <el-radio-button ghost :label="REGION_TYPE.UNLIMITED">不限</el-radio-button>
          <el-radio-button ghost :label="REGION_TYPE.REGION">按省市</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="targetingForm.regionType === REGION_TYPE.REGION && cityData.length" label="地域选择">
        <CascaderSelector
          v-model="targetingForm.region"
          :options="cityData"
          :props="{ multiple: true, value: 'id', label: 'value' }"
        ></CascaderSelector>
      </el-form-item>

      <el-form-item label="性别">
        <el-radio-group v-model="targetingForm.gender">
          <el-radio-button ghost :label="GENDER_TYPE.UNLIMITED">不限</el-radio-button>
          <el-radio-button ghost :label="GENDER_TYPE.GENDER_MALE">男</el-radio-button>
          <el-radio-button ghost :label="GENDER_TYPE.GENDER_FEMALE">女</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="年龄">
        <MixedElCheckBoxGroup v-model="targetingForm.age" @onCheckboxChange="onAgeCheckboxChange">
          <el-checkbox-button ghost :label="AGE_TYPES.UNLIMITED">不限</el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_18_23">18-23岁</el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_24_30">24-30岁</el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_31_40">31-40岁</el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_41_49">41-49岁</el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_ABOVE_50">大于等于50岁</el-checkbox-button>
        </MixedElCheckBoxGroup>
      </el-form-item>

      <el-form-item label="平台">
        <el-radio-group v-model="targetingForm.platform">
          <el-radio-button ghost :label="PLATFORM.UNLIMITED">不限</el-radio-button>
          <el-radio-button ghost :label="PLATFORM.ANDROID">Android</el-radio-button>
          <el-radio-button ghost :label="PLATFORM.IOS">IOS</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="过滤已转化用户">
        <el-radio-group v-model="targetingForm.hide_if_converted">
          <el-radio-button v-for="option in v3HideIfConvertedOptions" :key="option.value" ghost :label="option.value">
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="supportsConvertedTimeDuration" label="过滤时间">
        <el-radio-group v-model="targetingForm.converted_time_duration">
          <el-radio-button ghost :label="CONVERTED_TIME_DURATION.NONE">不限</el-radio-button>
          <el-radio-button ghost :label="CONVERTED_TIME_DURATION.TODAY">当天</el-radio-button>
          <el-radio-button ghost :label="CONVERTED_TIME_DURATION.SEVEN_DAY">7天</el-radio-button>
          <el-radio-button ghost :label="CONVERTED_TIME_DURATION.ONE_MONTH">1个月</el-radio-button>
          <el-radio-button ghost :label="CONVERTED_TIME_DURATION.THREE_MONTH">3个月</el-radio-button>
          <el-radio-button ghost :label="CONVERTED_TIME_DURATION.SIX_MONTH">6个月</el-radio-button>
          <el-radio-button ghost :label="CONVERTED_TIME_DURATION.TWELVE_MONTH">12个月</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="已安装用户">
        <el-radio-group v-model="targetingForm.hide_if_exists">
          <el-radio-button ghost :label="HIDE_IF_EXISTS.UNLIMITED">不限</el-radio-button>
          <el-radio-button ghost :label="HIDE_IF_EXISTS.FILTER">过滤</el-radio-button>
        </el-radio-group>
        <p style="color: red">只能用于iOS或安卓推广目的投放</p>
      </el-form-item>
    </template>

    <template v-else>
      <template v-if="isAdd">
        <el-form-item label="定向包名称" prop="name">
          <el-input style="width: 320px" v-model="targetingForm.name"></el-input>
        </el-form-item>

        <el-form-item label="描述">
          <el-input style="width: 320px" type="textarea" v-model="targetingForm.description"></el-input>
        </el-form-item>

        <el-form-item label="账号选择">
          <el-select
            v-model="targetingForm.account"
            :popper-append-to-body="false"
            value-key="id"
            filterable
            style="width: 320px"
            @change="onAccountChange"
          >
            <el-option v-for="account in accountList" :key="account.id" :label="account.name" :value="account"></el-option>
          </el-select>
          <p v-if="accountNotExsitMsg" style="color: red">{{ accountNotExsitMsg }}</p>
        </el-form-item>
      </template>

      <template v-if="!isProcedural">
        <el-form-item label="投放位置">
          <el-radio-group v-model="targetingForm.inventory_catalog">
            <el-radio-button ghost :label="INVENTORY_CATALOG.MANUAL"> 首选媒体 </el-radio-button>
            <el-radio-button ghost :label="INVENTORY_CATALOG.UNIVERSAL_SMART" disabled> 通投智选 </el-radio-button>
          </el-radio-group>
          <div class="inventory_types">
            <!-- 搜索广告批量复制、修改时 禁止修改 -->
            <el-checkbox-group :disabled="isSearchInventoryType && !isAdd" v-model="targetingForm.inventory_type">
              <el-checkbox :label="INVENTORY_TYPE.INVENTORY_FEED" @change="onInventoryTypeChange">今日头条</el-checkbox>
              <el-checkbox :label="INVENTORY_TYPE.INVENTORY_VIDEO_FEED" @change="onInventoryTypeChange">西瓜视频</el-checkbox>
              <el-checkbox :label="INVENTORY_TYPE.INVENTORY_AWEME_FEED" @change="onInventoryTypeChange">抖音短视频</el-checkbox>
              <el-checkbox :label="INVENTORY_TYPE.INVENTORY_TOMATO_NOVEL" @change="onInventoryTypeChange">番茄小说</el-checkbox>
              <el-checkbox :label="INVENTORY_TYPE.INVENTORY_UNION_SLOT" @change="onInventoryTypeChange">穿山甲</el-checkbox>
              <!-- <el-checkbox :label="INVENTORY_TYPE.UNION_BOUTIQUE_GAME" @change="onInventoryTypeChange">ohayoo精品游戏</el-checkbox> -->
              <el-checkbox :label="INVENTORY_TYPE.INVENTORY_SEARCH" @change="onInventoryTypeSearchChange">搜索计划</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <!-- 投放位置只有穿山甲时显示 -->
        <el-form-item label="投放形式" v-if="unionVideoTypeVisible">
          <el-radio-group v-model="targetingForm.union_video_type">
            <el-radio-button ghost :label="UNIOIN_VIDEO_TYPE.REWARDED_VIDEO"> 激励视频 </el-radio-button>
            <el-radio-button ghost :label="UNIOIN_VIDEO_TYPE.ORIGINAL_VIDEO"> 原生 </el-radio-button>
            <el-radio-button ghost :label="UNIOIN_VIDEO_TYPE.SPLASH_VIDEO" disabled> 开屏 </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </template>

      <el-form-item label="人群包">
        <el-radio-group v-model="targetingForm.audienceType" @change="onAudienceTypeChange">
          <el-radio-button ghost :label="AUDIENCE_TYPE.UNLIMITED"> 不限 </el-radio-button>
          <el-radio-button ghost :label="AUDIENCE_TYPE.AUDIENCE"> 定向或排除人群 </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="targetingForm.audienceType === AUDIENCE_TYPE.AUDIENCE">
        <div v-if="Object.keys(targetingForm.audiences).length" style="max-width: 1400px">
          <AudiencesTable
            :value="targetingForm.audiences"
            :data="audienceData"
            :accounts="[targetingForm.account]"
            @change="onAudienceResultChange"
          >
            <el-table-column prop="userCount" show-overflow-tooltip width="90" label="覆盖数量"> </el-table-column>
          </AudiencesTable>
        </div>

        <div v-else>请先选择账号</div>
      </el-form-item>

      <el-form-item label="地域">
        <el-radio-group v-model="targetingForm.regionType">
          <el-radio-button ghost :label="REGION_TYPE.UNLIMITED"> 不限 </el-radio-button>
          <el-radio-button ghost :label="REGION_TYPE.REGION"> 按省市 </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="targetingForm.regionType === REGION_TYPE.REGION && cityData.length" label="地域选择">
        <div style="max-width: 1400px">
          <CascaderSelector
            v-model="targetingForm.region"
            :options="cityData"
            :props="{ multiple: true, value: 'id', label: 'value' }"
          ></CascaderSelector>
        </div>

        <el-radio-group v-model="targetingForm.location_type">
          <el-radio :label="LOCATION_TYPE.HOME">居住在该地区的用户</el-radio>
          <el-radio :label="LOCATION_TYPE.TRAVEL">到该地区旅行的用户</el-radio>
          <el-radio :label="LOCATION_TYPE.ALL">该地区内的所有用户</el-radio>
          <el-radio :label="LOCATION_TYPE.CURRENT">正在该地区的用户</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="性别">
        <el-radio-group v-model="targetingForm.gender">
          <el-radio-button ghost :label="GENDER_TYPE.UNLIMITED"> 不限 </el-radio-button>
          <el-radio-button ghost :label="GENDER_TYPE.GENDER_MALE"> 男 </el-radio-button>
          <el-radio-button ghost :label="GENDER_TYPE.GENDER_FEMALE"> 女 </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="年龄">
        <MixedElCheckBoxGroup v-model="targetingForm.age" @onCheckboxChange="onAgeCheckboxChange">
          <el-checkbox-button ghost :label="AGE_TYPES.UNLIMITED">不限</el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_18_23"> 18-23岁 </el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_24_30"> 24-30岁 </el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_31_40"> 31-40岁 </el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_BETWEEN_41_49"> 41-49岁 </el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.AGE_ABOVE_50"> 大于等于50岁 </el-checkbox-button>
          <el-checkbox-button ghost :label="AGE_TYPES.MORE"> 更多分段 </el-checkbox-button>
        </MixedElCheckBoxGroup>
      </el-form-item>
      <el-form-item v-if="targetingForm.age.includes(AGE_TYPES.MORE)">
        <div class="c-select-item">
          <div class="c-header">
            <span class="c-header-title">已选：{{ targetingForm.moreAge.length }}个年龄分段</span>
            <span class="c-header-clear" @click="targetingForm.age = [AGE_TYPES.UNLIMITED]"> 清空全部 </span>
          </div>
          <div class="c-selecter-content">
            <el-checkbox
              :indeterminate="moreAgeIsIndeterminate"
              v-model="moreAgeIsCheckAll"
              @change="moreAgeCheckAll"
              class="c-version-item"
              label="All"
            >
              全选
            </el-checkbox>
            <el-checkbox-group v-model="targetingForm.moreAge">
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_18_19"> 18-19岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_20_23"> 20-23岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_24_30"> 24-30岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_31_35"> 31-35岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_36_40"> 36-40岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_41_45"> 41-45岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_46_50"> 46-50岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_51_55"> 51-55岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_BETWEEN_56_59"> 56-59岁 </el-checkbox>
              <el-checkbox class="c-version-item" :label="AGE_TYPES.AGE_ABOVE_60"> 大于等于60岁 </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form-item>
      <template v-if="!isProcedural">
        <el-form-item label="兴趣行为定向">
          <el-radio-group v-model="targetingForm.interest_action_mode">
            <el-radio-button ghost :label="INTEREST_ACTION_TYPES.UNLIMITED"> 不限 </el-radio-button>
            <el-radio-button ghost :label="INTEREST_ACTION_TYPES.RECOMMEND"> 系统推荐 </el-radio-button>
            <el-radio-button ghost :label="INTEREST_ACTION_TYPES.CUSTOM"> 自定义 </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <template v-if="targetingForm.interest_action_mode === INTEREST_ACTION_TYPES.CUSTOM">
          <template v-if="targetingForm.account.id">
            <el-form-item label="行为">
              <action-interest
                v-model="targetingForm.action_tags"
                :accounts="[targetingForm.account]"
                :action-scene="targetingForm.action_scene"
                :action-days="targetingForm.action_days"
                :max="350"
                action
                @on-days="setDays"
                @on-scene="setScene"
              />
            </el-form-item>

            <el-form-item label="兴趣" v-if="targetingForm.interest_action_mode === INTEREST_ACTION_TYPES.CUSTOM">
              <action-interest v-model="targetingForm.word_tags" :accounts="[targetingForm.account]" :max="350" />
            </el-form-item>
          </template>

          <el-form-item v-else>
            <div>请先选择账号</div>
          </el-form-item>
        </template>
      </template>

      <el-form-item label="平台">
        <el-radio-group v-model="targetingForm.platform" :disabled="platformDisabled">
          <el-radio-button ghost :label="PLATFORM.UNLIMITED"> 不限 </el-radio-button>
          <el-radio-button ghost :label="PLATFORM.ANDROID"> Android </el-radio-button>
          <el-radio-button ghost :label="PLATFORM.IOS"> IOS </el-radio-button>
          <el-radio-button ghost :label="PLATFORM.HARMONY"> 鸿蒙 </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="安卓版本" v-if="targetingForm.platform === PLATFORM.ANDROID">
        <DevicePlatformVersion v-model="targetingForm.android_osv" :data="androidVersions" title="安卓版本" />
      </el-form-item>
      <el-form-item label="IOS版本" v-if="targetingForm.platform === PLATFORM.IOS">
        <DevicePlatformVersion v-model="targetingForm.ios_osv" :data="IOSVersions" title="IOS版本" />
      </el-form-item>
      <el-form-item label="鸿蒙版本" v-if="targetingForm.platform === PLATFORM.HARMONY">
        <DevicePlatformVersion v-model="targetingForm.harmony_osv" :data="harmonyVersions" title="鸿蒙版本" />
      </el-form-item>

      <el-form-item label="过滤已转化">
        <el-radio-group v-model="targetingForm.hide_if_converted">
          <el-radio-button ghost :label="HIDE_IF_CONVERTED.NO_EXCLUDE"> 不限制 </el-radio-button>
          <el-radio-button ghost :label="HIDE_IF_CONVERTED.PROMOTION"> 计划 </el-radio-button>
          <el-radio-button ghost :label="HIDE_IF_CONVERTED.PROJECT"> 推广项目 </el-radio-button>
          <el-radio-button ghost :label="HIDE_IF_CONVERTED.ADVERTISER"> 计划账户 </el-radio-button>
          <el-radio-button ghost :label="HIDE_IF_CONVERTED.APP"> APP </el-radio-button>
          <el-radio-button ghost :label="HIDE_IF_CONVERTED.CUSTOMER"> 客户 </el-radio-button>
          <el-radio-button ghost :label="HIDE_IF_CONVERTED.ORGANIZATION"> 组织 </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <template v-if="!isProcedural">
        <el-form-item label="设备类型" v-if="!isSearchInventoryType">
          <MixedElCheckBoxGroup v-model="targetingForm.device_type">
            <el-checkbox-button ghost :label="DEVICE_TYPE_CATEGORY.UNLIMITED">不限</el-checkbox-button>
            <el-checkbox-button ghost :label="DEVICE_TYPE_CATEGORY.MOBILE">智能手机</el-checkbox-button>
            <el-checkbox-button ghost :label="DEVICE_TYPE_CATEGORY.PAD">平板</el-checkbox-button>
          </MixedElCheckBoxGroup>
          <p style="color: red">提示：非白名单账户会报错，慎重选择！</p>
        </el-form-item>

        <el-form-item label="智能放量">
          <el-radio-group v-model="targetingForm.auto_extend_enabled">
            <el-radio-button ghost :label="AUTO_EXTEND_ENABLE.OFF"> 关闭 </el-radio-button>
            <el-radio-button ghost :label="AUTO_EXTEND_ENABLE.ON"> 开启 </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="targetingForm.auto_extend_enabled === AUTO_EXTEND_ENABLE.ON">
          <CascaderSelector
            v-model="targetingForm.autotend"
            :options="autotendData"
            :props="{ multiple: true, value: 'id', label: 'value' }"
          ></CascaderSelector>
        </el-form-item>

        <el-form-item label="网络" v-if="!isSearchInventoryType">
          <MixedElCheckBoxGroup v-model="targetingForm.ac">
            <el-checkbox-button ghost :label="AC.NONE">不限</el-checkbox-button>
            <el-checkbox-button ghost :label="AC.WIFI"> WIFI </el-checkbox-button>
            <el-checkbox-button ghost :label="AC.AC2G"> 2G </el-checkbox-button>
            <el-checkbox-button ghost :label="AC.AC3G"> 3G </el-checkbox-button>
            <el-checkbox-button ghost :label="AC.AC4G"> 4G </el-checkbox-button>
            <el-checkbox-button ghost :label="AC.AC5G"> 5G </el-checkbox-button>
          </MixedElCheckBoxGroup>
        </el-form-item>

        <el-form-item label="穿山甲媒体定向">
          <el-radio-group v-model="targetingForm.superior_popularity_type">
            <el-radio-button ghost :label="SUPERIOR_POPULARITY_TYPE.UNLIMITED"> 不限 </el-radio-button>
            <el-radio-button ghost :label="SUPERIOR_POPULARITY_TYPE.GAME"> 游戏优质媒体 </el-radio-button>
            <el-radio-button ghost :label="SUPERIOR_POPULARITY_TYPE.CUSTOM" disabled> 自定义 </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="新用户">
          <MixedElCheckBoxGroup v-model="targetingForm.activate_type">
            <el-checkbox-button ghost :label="ACTIVATE_TYPE.UNLIMITED">不限</el-checkbox-button>
            <el-checkbox-button ghost :label="ACTIVATE_TYPE.WITH_IN_A_MONTH"> 一个月以内 </el-checkbox-button>
            <el-checkbox-button ghost :label="ACTIVATE_TYPE.ONE_MONTH_2_THREE_MONTH"> 一个月到三个月 </el-checkbox-button>
            <el-checkbox-button ghost :label="ACTIVATE_TYPE.THREE_MONTH_EAILIER"> 三个月或更早 </el-checkbox-button>
          </MixedElCheckBoxGroup>
        </el-form-item>

        <template v-if="[PLATFORM.ANDROID, PLATFORM.UNLIMITED].includes(targetingForm.platform)">
          <el-form-item label="手机品牌">
            <el-radio-group v-model="targetingForm.brand_type">
              <el-radio-button ghost :label="BRAND_TYPE.UNLIMITED"> 不限 </el-radio-button>
              <el-radio-button ghost :label="BRAND_TYPE.CUSTOM"> 按手机品牌 </el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="targetingForm.brand_type === BRAND_TYPE.CUSTOM">
            <CascaderSelector
              v-model="targetingForm.brand"
              :options="brandData"
              :props="{ multiple: true, value: 'id', label: 'value' }"
            ></CascaderSelector>
          </el-form-item>
        </template>

        <el-form-item label="手机价格" v-if="!isSearchInventoryType">
          <el-radio-group v-model="targetingForm.price_type">
            <el-radio-button ghost :label="PRICE_TYPE.UNLIMITED"> 不限 </el-radio-button>
            <el-radio-button ghost :label="PRICE_TYPE.CUSTOM"> 自定义 </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="targetingForm.price_type === PRICE_TYPE.CUSTOM">
          <range-price v-model="targetingForm.launch_price" @on-short="changePriceValue" :closeMarks="true" />
        </el-form-item>
      </template>
    </template>
  </el-form>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { MessageBox } from 'element-ui'
import { isArray } from '@/common/js/utils'
import ActionInterest from '@/views/create/toutiaonew_local/components/actioninterest'
import autotendData from '@/data/toutiao/auto_extend_targets'
import RangePrice from '@/components/range-price/range-price'
import DevicePlatformVersion from '@/components/version/'

import CascaderSelector from '@/components/cascader-select/index.vue'
import MixedElCheckBoxGroup from '@/components/check-box-group/index.vue'
import AudiencesTable from '@/views/edit/kuaishou/components/audiences-table/index.vue'
import {
  AUDIENCE_TYPE,
  INVENTORY_CATALOG,
  INVENTORY_TYPE,
  UNIOIN_VIDEO_TYPE,
  REGION_TYPE,
  LOCATION_TYPE,
  GENDER_TYPE,
  AGE_TYPES,
  INTEREST_ACTION_TYPES,
  PLATFORM,
  DEVICE_TYPE,
  DEVICE_TYPE_CATEGORY,
  AUTO_EXTEND_ENABLE,
  AC,
  SUPERIOR_POPULARITY_TYPE,
  HIDE_IF_CONVERTED,
  CONVERTED_TIME_DURATION,
  HIDE_IF_EXISTS,
  ACTIVATE_TYPE,
  BRAND_TYPE,
  PRICE_TYPE,
  TOUTIAO_AD_MARKETING_SCENE,
  getToutiaoAdMarketingSceneByVersion
} from '../../model/toutiao_targeting_consts.js'

import { getInitForm, useInitialTargetingForm, useInterestActionBehavior, useAudience, useAccountList } from './useToutiaoTargetingForm.js'

//  eslint-disable-next-line
const props = defineProps({
  isAdd: {
    // 是否是新增模式
    type: Boolean,
    default: false
  },
  // 是否自动投放、用于判断部分定向在自动投放模式下是否显示
  isProcedural: {
    type: Boolean,
    default: false
  },
  //  是否禁用平台选择，用于批量修改、复制流程
  platformDisabled: {
    type: Boolean,
    default: false
  },
  labelWidth: {
    type: String,
    default: '120px'
  },
  isV3: {
    type: Boolean,
    default: false
  },
  adMarketingSceneDisabled: {
    type: Boolean,
    default: false
  }
})

const formRef = ref(null)

const accountNotExsitMsg = ref('')

const rules = {
  name: [
    { required: true, message: '请输入名称', trigger: 'blur' },

    {
      min: 1,
      max: 20,
      message: '长度在 1 到 20 个字符',
      trigger: 'blur'
    }
  ]
}

const { targetingForm, cityData, brandData, androidVersions, IOSVersions, harmonyVersions, autotendList } = useInitialTargetingForm()
const { setDays, setScene } = useInterestActionBehavior()
const { audienceData, getAudienceData, onAudienceTypeChange, onAudienceResultChange } = useAudience()
const { accountList, getAccounts, onAccountChange } = useAccountList({ getAudienceData })

const isToutiaoV3 = computed(() => targetingForm.value.ad_marketing_scene === TOUTIAO_AD_MARKETING_SCENE.VERSION_3)
const getDefaultAdMarketingScene = () => getToutiaoAdMarketingSceneByVersion(props.isV3)

// 鸿蒙平台时 harmony_osv 必填，切换到鸿蒙若未设置则默认不限
watch(
  () => targetingForm.value.platform,
  (platform) => {
    if (platform === PLATFORM.HARMONY && !targetingForm.value.harmony_osv) {
      targetingForm.value.harmony_osv = 'NONE'
    }
  }
)

const v3AgeValues = [
  AGE_TYPES.UNLIMITED,
  AGE_TYPES.AGE_BETWEEN_18_23,
  AGE_TYPES.AGE_BETWEEN_24_30,
  AGE_TYPES.AGE_BETWEEN_31_40,
  AGE_TYPES.AGE_BETWEEN_41_49,
  AGE_TYPES.AGE_ABOVE_50
]
const v3HideIfConvertedOptions = [
  { label: '不限', value: HIDE_IF_CONVERTED.NO_EXCLUDE },
  { label: '项目', value: HIDE_IF_CONVERTED.PROJECT },
  { label: '公司账户', value: HIDE_IF_CONVERTED.CUSTOMER },
  { label: '投放账户', value: HIDE_IF_CONVERTED.ADVERTISER },
  { label: '应用', value: HIDE_IF_CONVERTED.APP },
  { label: '组织账户', value: HIDE_IF_CONVERTED.ORGANIZATION }
]
const v3HideIfConvertedValues = v3HideIfConvertedOptions.map((option) => option.value)

const supportsConvertedTimeDuration = computed(() => {
  const { hide_if_converted } = targetingForm.value
  return ![HIDE_IF_CONVERTED.PROJECT, HIDE_IF_CONVERTED.ADVERTISER].includes(hide_if_converted)
})

const onAdMarketingSceneChange = (adMarketingScene) => {
  const currentForm = targetingForm.value
  const nextForm = getInitForm({
    defaultAccount: currentForm.account,
    adMarketingScene
  })

  Object.assign(nextForm, {
    targetingId: currentForm.targetingId,
    name: currentForm.name,
    description: currentForm.description,
    account: currentForm.account,
    audienceType: currentForm.audienceType,
    audiences: currentForm.audiences,
    regionType: currentForm.regionType,
    region: currentForm.region,
    gender: currentForm.gender,
    age: currentForm.age,
    platform: currentForm.platform,
    hide_if_converted: currentForm.hide_if_converted
  })

  if (adMarketingScene === TOUTIAO_AD_MARKETING_SCENE.VERSION_3) {
    if (!isArray(currentForm.age) || !currentForm.age.every((age) => v3AgeValues.includes(age))) {
      nextForm.age = [AGE_TYPES.UNLIMITED]
    }
    if (!v3HideIfConvertedValues.includes(currentForm.hide_if_converted)) {
      nextForm.hide_if_converted = HIDE_IF_CONVERTED.NO_EXCLUDE
    }
  }

  targetingForm.value = nextForm
}

const isSearchInventoryType = computed(() => {
  const { inventory_type } = targetingForm.value
  return inventory_type.includes(INVENTORY_TYPE.INVENTORY_SEARCH)
})

const moreAgeIsCheckAll = ref(false)
const moreAgeIsIndeterminate = computed(() => {
  const { moreAge } = targetingForm.value
  moreAgeIsCheckAll.value = moreAge.length === 10
  return moreAge.length > 0 && moreAge.length < 10
})
const moreAgeCheckAll = (val) => {
  if (val) {
    targetingForm.value.moreAge = [
      AGE_TYPES.AGE_BETWEEN_18_19,
      AGE_TYPES.AGE_BETWEEN_20_23,
      AGE_TYPES.AGE_BETWEEN_24_30,
      AGE_TYPES.AGE_BETWEEN_31_35,
      AGE_TYPES.AGE_BETWEEN_36_40,
      AGE_TYPES.AGE_BETWEEN_41_45,
      AGE_TYPES.AGE_BETWEEN_46_50,
      AGE_TYPES.AGE_BETWEEN_51_55,
      AGE_TYPES.AGE_BETWEEN_56_59,
      AGE_TYPES.AGE_ABOVE_60
    ]
  } else {
    targetingForm.value.moreAge = []
  }
}
const onAgeCheckboxChange = (vals) => {
  const [firstLabel] = vals
  if (firstLabel === AGE_TYPES.MORE) {
    targetingForm.value.age.splice(0, 1)
  } else if (vals.includes(AGE_TYPES.MORE)) {
    targetingForm.value.age = [AGE_TYPES.MORE]
  }
}

/**
 * @description: 搜索广告不可选
 * @return {*}
 */
const onInventoryTypeChange = () => {
  targetingForm.value.inventory_type = targetingForm.value.inventory_type.filter((item) => item !== INVENTORY_TYPE.INVENTORY_SEARCH)
}
/**
 * @description: 如果选择搜索广告，清空其他版位
 * @return {*}
 */
const onInventoryTypeSearchChange = (val) => {
  if (val) {
    targetingForm.value.inventory_type = [INVENTORY_TYPE.INVENTORY_SEARCH]
  }
}
const unionVideoTypeVisible = computed(() => {
  const { inventory_type } = targetingForm.value
  return inventory_type.length === 1 && inventory_type.includes(INVENTORY_TYPE.INVENTORY_UNION_SLOT)
})

function changePriceValue(e) {
  targetingForm.value.launch_price = e
}

// eslint-disable-next-line
defineExpose({
  validate: () => formRef.value.validate(),
  getForm: () => {
    const form = {
      ...targetingForm.value,
      ad_marketing_scene: targetingForm.value.ad_marketing_scene || getDefaultAdMarketingScene()
    }

    if (isToutiaoV3.value) {
      if (!supportsConvertedTimeDuration.value) {
        delete form.converted_time_duration
      }
    }

    return form
  },
  async setForm(form) {
    await getAccounts()
    if (form.account?.id) {
      const existAccount = accountList.value.find((item) => item.id === form.account.id)
      if (existAccount) {
        getAudienceData(form.account.id)
      } else {
        // 账号不存在时，清除人群包信息
        form.account = {}
        form.audiences = {}
        form.audienceType = AUDIENCE_TYPE.UNLIMITED

        // MessageBox.alert('检测到已选账号不存在，已清空账号信息和人群包信息，如需配置请重新选择', {
        //   title: '提示',
        //   confirmButtonText: '知道了',
        //   customClass: 'targeting-error-account-alert-box'
        // })

        accountNotExsitMsg.value = '检测到已选账号不存在，已清空账号信息和人群包信息，如需配置请重新选择'

        setTimeout(() => {
          accountNotExsitMsg.value = ''
        }, 10 * 1000)
      }
    }

    targetingForm.value = {
      ...form,
      ad_marketing_scene: form.ad_marketing_scene || getDefaultAdMarketingScene()
    }
  }
})
</script>

<style lang="scss" scoped>
.c-select-item {
  width: 400px;
  background-color: #fff;
  border: solid 1px #dee4f5;
  .c-header {
    padding: 0 12px;
    height: 34px;
    color: #333;
    border-bottom: solid 1px #dee4f5;
    background-color: #fafbfe;

    .c-header-title,
    .c-header-clear {
      height: 34px;
      line-height: 34px;
      vertical-align: middle;
    }

    .c-header-clear {
      color: #598fe6;
      float: right;
      cursor: pointer;
    }
  }

  .c-selecter-content {
    padding: 8px;
    .c-version-item {
      display: block;
      height: 34px;
      line-height: 34px;
      margin-left: 12px;
    }
  }
}
.toutiao-targeting-wrapper {
  height: calc(100% - 40px);
  overflow: hidden;
  overflow-y: auto;
  position: relative;

  padding: 80px 0;
  .el-form {
    width: 1420px;
    margin: 0 auto;

    .inventory_types {
      .check-all {
        margin-right: 30px;
      }
      display: flex;
    }
  }
}

.submit-btns {
  padding: 15px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;
  width: 100%;
  text-align: right;
  position: absolute;
  // bottom: 0;
}
</style>
